var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import './SearchInput.scss';
// Could also be called base input because all it does is lifting the onChange event to parent component
var SearchInput = /** @class */ (function (_super) {
    __extends(SearchInput, _super);
    function SearchInput(props) {
        var _this = _super.call(this, props) || this;
        _this.handleInputChange = function (event) {
            _this.props.onInputChange(event.target.value);
        };
        return _this;
    }
    SearchInput.prototype.render = function () {
        return (React.createElement("input", { className: "searchInput " + this.props.className, placeholder: this.props.inputPlaceholder, type: "text", value: this.props.inputValue, onChange: this.handleInputChange }));
    };
    return SearchInput;
}(React.Component));
export default SearchInput;
